/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.upgrade.management.rpc.UpgradeConfigInAppRpc
 */

import type {
  ChirpAvroRpcDetails,
  Requestify,
  unhandledEnumCase,
  Default,
  HubspotMetadata,
} from 'rpc-client-utils';

export type CausalChainLink = {
  coordinates: ChirpMethodCoordinates;
  errorClass: string;
  errorMessage?: string;
};

export type ChirpMethodCoordinates = { service: string; method: string };

export type EmptyError = {
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry?: boolean;
};

export type ContentType =
  | 'DESCRIPTION'
  | 'HEADING'
  | 'BODY'
  | 'HEADING_SHORT'
  | 'BODY_SHORT'
  | unhandledEnumCase;

export type SeatProductType =
  | 'COMMERCE'
  | 'CORE'
  | 'FLEX'
  | 'FRONT_OFFICE'
  | 'SALES'
  | 'SERVICE'
  | unhandledEnumCase;

export type Recommendation = { hubType: string; correlationId?: string };

export type UpgradeConfig = {
  apiNames: Default<string[]>;
  recommendationResponse?: Recommendation;
  upgradeKey: string;
  team: string;
  featureStoreFeature: string;
  visualType?: string;
  visualKey?: string;
  pointLocation?: string;
  content: Default<UpgradeContentCommon[]>;
  pointType: Default<PointType>;
  status: Default<Status>;
};

export type UpgradeConfigProduct = {
  bestFitApiNameForPurchase: string;
  purchaseMotions: Default<string[]>;
  apiNames: Default<string[]>;
  recommendationResponse?: Recommendation;
  associatedSeats: Default<SeatProductType[]>;
  translatedFeatureDisplayName?: string;
  upgradeKey: string;
  team: string;
  featureStoreFeature: string;
  visualType?: string;
  visualKey?: string;
  pointLocation?: string;
  content: Default<UpgradeContentCommon[]>;
  pointType: Default<PointType>;
  status: Default<Status>;
};

export type UpgradeContentCommon = { contentType: ContentType; text: string };

export type UpgradeConfigError = {
  reason: ConfigErrorType;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type ConfigErrorType =
  | 'UPDATE_UPGRADE_CONFIG_FAILED'
  | 'CREATE_UPGRADE_CONFIG_FAILED'
  | 'MISSING_PORTAL_ID'
  | 'MISSING_USER_ID'
  | 'NO_UPGRADE_CONFIG_FOUND'
  | 'FEATURE_NOT_FOUND_IN_PRODUCT_CATALOG'
  | 'INVALID_API_NAMES'
  | 'MISSING_LIMIT_PLACEHOLDER'
  | unhandledEnumCase;

export type RequestWithPurchaseMotions = {
  shouldIncludePurchaseMotions: Default<boolean>;
  limit?: number;
  amountUsed?: number;
  upgradeKey: string;
};

export type UpgradeConfigProductResponse = {
  upgradeConfigProduct: UpgradeConfigProduct;
};

export type UpgradeConfigSetResponse = {
  upgradeConfigs: Default<UpgradeConfig[]>;
};

export type PointType =
  | 'PAYWALL'
  | 'LOCKED_FEATURE'
  | 'USAGE_LIMIT_BANNER'
  | 'REMOVE_BRANDING_BANNER'
  | 'LIMIT_PACK_BANNER'
  | 'USAGE_LIMIT_COUNTER'
  | 'LOCKED_NAV_ITEM'
  | unhandledEnumCase;

export type Status =
  | 'PLANNED'
  | 'ACTIVE'
  | 'ARCHIVED'
  | 'STALE'
  | unhandledEnumCase;

export type GetAllUpgradeConfigsResponseType = UpgradeConfigSetResponse;
export type GetAllUpgradeConfigsErrorType = EmptyError & HubspotMetadata;
export const getAllUpgradeConfigsRpc: ChirpAvroRpcDetails<
  undefined,
  GetAllUpgradeConfigsResponseType,
  GetAllUpgradeConfigsErrorType,
  false
> = {
  serviceName: 'com.hubspot.upgrade.management.rpc.UpgradeConfigInAppRpc',
  rpcName: 'getAllUpgradeConfigs',
  auth: 'app',
  fingerprint: 'AAAAAAAAAAABHRYAWfDMFpwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetUpgradeConfigWithPurchaseMotionsRequestType =
  Requestify<RequestWithPurchaseMotions>;
export type GetUpgradeConfigWithPurchaseMotionsResponseType =
  UpgradeConfigProductResponse;
export type GetUpgradeConfigWithPurchaseMotionsErrorType = UpgradeConfigError &
  HubspotMetadata;
export const getUpgradeConfigWithPurchaseMotionsRpc: ChirpAvroRpcDetails<
  GetUpgradeConfigWithPurchaseMotionsRequestType,
  GetUpgradeConfigWithPurchaseMotionsResponseType,
  GetUpgradeConfigWithPurchaseMotionsErrorType,
  false
> = {
  serviceName: 'com.hubspot.upgrade.management.rpc.UpgradeConfigInAppRpc',
  rpcName: 'getUpgradeConfigWithPurchaseMotions',
  auth: 'app',
  fingerprint: 'tGAGVi8wQP18cHvG8OluQ0VID-EQPFVs',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};
